export default __webpack_public_path__ + "static/media/selected-vertical-split.4974c45a.svg";